/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 14:33:48
 * @Explain: Dialog - 函数式
 */
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { DialogPlugin, DialogOptions } from 'tdesign-react';

interface DialogProps extends DialogOptions {
  iconName?: string;
}
// 弹窗
class Dialog {
  confirmDialog?: { hide: () => void };
  constructor() {
    this.confirmDialog = {
      hide: () => {},
    };
  }
  /** 关闭Dialog */
  onHide() {
    this.confirmDialog?.hide();
  }
  /** 确认框 */
  confirm(config: DialogProps) {
    this.confirmDialog = DialogPlugin.confirm({
      confirmBtn: intlGet('COMMON.DETERMINE'),
      cancelBtn: intlGet('COMMON.CANCEL'),
      onClose: () => {
        this.confirmDialog?.hide();
      },
      ...config,
      className: classNames(
        'default-td-dialog-confirm',
        { 'close-btn': config.closeBtn },
        config.className,
      ),
    });
  }
}

export default new Dialog();
